import React from 'react';
import StatCard from './StatCard';
import { CompetitorAnalysisComparison } from '../../../../../types/competitors';
import StatComparison from './StatComparison';
import PositioningSummary from './PositioningSummary';

interface CompetitorViewerStatsProps {
    data?: CompetitorAnalysisComparison;
}

const formatPercentage = (score: number) => `${Math.round(score * 100)}%`;

const getPercentageDifference = (ownScore: number, competitorScore: number) =>
    `${Math.round(Math.abs(ownScore - competitorScore) * 100)}%`;

const CompetitorViewerStats = ({ data }: CompetitorViewerStatsProps) => {
    const servicesDifference =
        (data?.ownServiceCount || 0) - (data?.competitorServiceCount || 0);
    const catalogSize = data?.catalogSize || 0;
    const ownCatalogMapped = catalogSize
        ? ((data?.ownServiceCount || 0) / catalogSize) * 100
        : 0;
    const competitorCatalogMapped = catalogSize
        ? ((data?.competitorServiceCount || 0) / catalogSize) * 100
        : 0;
    const catalogMappedDifference = ownCatalogMapped - competitorCatalogMapped;
    const ownAttributeDepth = data?.ownAttributeDepth?.score || 0;
    const competitorAttributeDepth = data?.competitorAttributeDepth?.score || 0;

    return (
        <div className='competitor-viewer__stats'>
            <StatCard title='services_live'>
                <StatComparison
                    ownText={String(data?.ownServiceCount || 0)}
                    competitorText={String(data?.competitorServiceCount || 0)}
                    isPositive={servicesDifference >= 0}
                />
            </StatCard>
            <StatCard title='catalog_mapped'>
                <StatComparison
                    ownText={formatPercentage(ownCatalogMapped / 100)}
                    competitorText={formatPercentage(
                        competitorCatalogMapped / 100
                    )}
                    differenceText={formatPercentage(
                        Math.abs(catalogMappedDifference) / 100
                    )}
                    isPositive={catalogMappedDifference >= 0}
                />
            </StatCard>
            <StatCard title='attribute_depth'>
                <StatComparison
                    ownText={formatPercentage(ownAttributeDepth)}
                    competitorText={formatPercentage(competitorAttributeDepth)}
                    differenceText={getPercentageDifference(
                        ownAttributeDepth,
                        competitorAttributeDepth
                    )}
                    isPositive={ownAttributeDepth >= competitorAttributeDepth}
                />
            </StatCard>
            <StatCard title='positioning'>
                <PositioningSummary
                    weLead={data?.advantagesOverCompetitor?.length || 0}
                    parity={data?.matchedServices?.length || 0}
                    gaps={data?.gapsVsCompetitor?.length || 0}
                />
            </StatCard>
        </div>
    );
};

export default CompetitorViewerStats;
